import {
    TextHelper,
    SmallTextHelper,
    UrlHelper,
    //ArrayHelper
} from '../../PrismicHelpers';

export const heroBannerSlice = (data) => {
    // Always take the slice_type and return it with data, helper will know what to display/render
    const dataType = data.slice_type;
    // Non repetable data inside slice
    const sliceFixedData = data.primary;
    // Repetable data (example: buttons)
    const sliceRepetableData = data.items;
    // Data to send to the array of slices (always type and data if needed)
    let dataToSend = {
        type: dataType,
        background_options: SmallTextHelper(sliceFixedData.background_options),
        //background_color: SmallTextHelper(sliceFixedData.background_color),
        background_image: UrlHelper(sliceFixedData.background_image),
        //text_color: SmallTextHelper(sliceFixedData.text_color),
        text_alignment: SmallTextHelper(sliceFixedData.text_alignment),
        headline: TextHelper(sliceFixedData.headline),
        subtitle: TextHelper(sliceFixedData.subtitle),
        buttons: !(sliceRepetableData && sliceRepetableData.length > 0) ? null : sliceRepetableData.map(element => {
            return {
                button_type: SmallTextHelper(element.button_type),
                button_link: TextHelper(element.button_link),
                button_text: TextHelper(element.button_text),
                button_color: SmallTextHelper(element.button_color)
            }
        })
    };
    return dataToSend;
}


// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-slice-helpers/single-slice-helpers/heroBannerSlice.js